<div class="container flex flex-col gap-[8px] justify-start items-start">
  <div class="title">
    {{ contingentSubscription.free }}
    {{ '+BOOKING.OVERVIEW.CONTINGENT_SUBSCRIPTION.VOUCHERS' | translate }}
  </div>
  <div class="details-container">
    <div>
      {{ '+BOOKING.OVERVIEW.CONTINGENT_SUBSCRIPTION.PURCHASED' | translate }}
      {{ contingentSubscription.invoiceDate | date }}
      ({{ '+BOOKING.OVERVIEW.CONTINGENT_SUBSCRIPTION.VIESSMANN_PARTNER_SHOP' | translate }})
    </div>
    <div class="flex flex-row gap-[4px] justify-start items-center">
      <div>
        {{ '+BOOKING.OVERVIEW.CONTINGENT_SUBSCRIPTION.VALID_UNTIL_DATE' | translate }}
        {{ contingentSubscriptionValidDate }}
      </div>
      <mat-icon
        class="info-icon"
        [matTooltip]="
          '+BOOKING.OVERVIEW.CONTINGENT_SUBSCRIPTION.VALID_UNTIL_DATE_TOOLTIP' | translate
        "
        matTooltipPosition="above"
      >
        info_outline
      </mat-icon>
    </div>
    <div>
      {{ '+BOOKING.OVERVIEW.CONTINGENT_SUBSCRIPTION.INVOICE_NUMBER' | translate }}
      {{ contingentSubscription.invoice }}
    </div>
  </div>
  <button
    class="full-width assign-btn"
    data-at-assign-to-device-button
    mat-raised-button
    color="primary"
    gtm="onGoToPage"
    gtmAction="Booking"
    gtmCategory="bookingOverview"
    (click)="onActivateVoucher()"
  >
    {{ '+BOOKING.OVERVIEW.CONTINGENT_SUBSCRIPTION.ASSIGN_TO_DEVICE_BTN' | translate }}
  </button>
</div>
